import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/usr/organisations', params),
    getById: (id) => Api.get('/usr/organisation/' + id, null),
    save: (entity) => Api.post('/usr/organisation', entity),
    update: (id, entity) => Api.put('/usr/organisation/' + id, entity),
    setDefault: (id) => Api.put('/usr/organisation/' + id + '/setdefault'),
    getDepartments: (id) => Api.get('/usr/organisation/' + id + '/departments'),
    delete: (id) => Api.delete('/usr/organisation/' + id),
    search: (searchText) => Api.get('/usr/organisations/search', {q: searchText}),
    getContacts: (id) => Api.get('/usr/organisation/' + id + '/contacts'),
    addContact: (id, contactId) => Api.put('/usr/organisation/' + id + '/contact', {contactId: contactId}),
    removeContact: (id, contactId) => Api.delete('/usr/organisation/' + id + '/contact/' + contactId),
};
